export default __webpack_public_path__ + "resources/icons/n111-9553.png";